<template>
  <right-menu-item
    v-if="show"
    @click.prevent="click"
    :class="{ 'muted': !isActive }"
    :text="$t('Download ZIP')"
    :loading="loading"
    icon="download"
  />
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import { FolderApi } from '@/frontapp/test-api'
import { trackEvent } from '@/frontapp/gtm'
import { saveAs } from 'file-saver'
import Toast from '@/frontapp/mixins/actions/Toast'

// import { trackEvent } from '../../gtm'

const folderApi = new FolderApi({}, '/api/v2')

export default {
  data() {
    return {
      loading: false
    }
  },
  computed: {
    show() {
      const list = this.bcFolderStore?.current?.id === 0 ? this.bcFolderStore.listChildren[0] : [...this.bcSelectedStore.selectableMap.values()]
      return list && list.length
    },
    isActive() {
      return this.bcSelectedStore.listSelected.length > 0 || (this.bcSelectedStore.list.length > 0 && this.bcSelectedStore.listSelected.length === 0)
      /*&& this.bcSelectedStore.listSelected.every(item => item.can_edit)*/
    },
    ...mapStores(useBcSelectedStore, useBcFolderStore)
  },
  methods: {
    async click() {
      this.loading = true

      let itemsKey

      if (this.bcSelectedStore.listSelected.length > 0) {
        itemsKey = 'listSelected'
      } else if (this.bcSelectedStore.list.length > 0 && this.bcSelectedStore.listSelected.length === 0) {
        itemsKey = 'list'
      }

      const documentIds = this.bcSelectedStore[itemsKey]
        .filter(e => e.type === 'document')
        .map(e => e.id)

      const folderIds = this.bcSelectedStore[itemsKey]
        .filter(e => e.type === 'folder')
        .map(e => e.id)

      try {
        const requestZipResponse = await folderApi.folderRequestZipDownloadShared({ folderIds, documentIds })
        if (requestZipResponse.status === 204) {
          Toast(
            'error',
            this.$t('We are sorry, but selected documents and folders doesn\'t contains any files for ZIP.')
          )
        } else {
          saveAs('/api/v2/zip/' + requestZipResponse.data.hash, requestZipResponse.data.file_name + '.zip')
        }
      } catch (e) {
        Toast(
          'error',
          this.$t('We are so sorry, but there was an error while we tried to prepare ZIP for you.')
        )
      }

      this.bcSelectedStore.reload()
      this.loading = false
      trackEvent(this.$route.matched[0].name, 'downloadZipShared')
    },
  }
}
</script>

<style lang="scss" scoped></style>
